import {productSlice} from './productSlice';

export default productSlice.reducer;
